/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import TransactionsTable from "../Common/Transactions/TransactionsTable";
import Pagination from "../Common/Pagination";
import TransactionsSearchForm from "../Common/Transactions/TransactionsSearchForm";
import ajaxBank from "../../util/remote/ajaxBank";

function AccountActivations() {
  const [accountActivations, setAccountActivations] = useState(false);
  const [activationSearchTerm, setActivationSearchTerm] = useState("");
  const [activationStartDate, setActivationStartDate] = useState("");
  const [activationEndDate, setActivationEndDate] = useState("");
  const [activationPage,setActivationPage] = useState(1)
  const [activationMeta,setActivationMeta] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const getAccountActivations = async (currentPage) => {
      setLoading(true);
      const server_response = await ajaxBank.fetchAccountActivationInvoices(currentPage);
      setLoading(false);
      if (server_response.status === "OK") {
        setActivationMeta(server_response.details.meta.totalPages);
        setAccountActivations(server_response.details.data || []);
      } else {
        setAccountActivations([]);
      }
  };

  const searchAccountActivations = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxBank.searchAccountActivationInvoices(activationSearchTerm,activationStartDate,activationEndDate,activationPage);
      setLoading2(false);
      if (server_response.status === "OK") {
        setActivationMeta(server_response.details.meta.totalPages);
        setAccountActivations(server_response.details.data || []);
      } else {
        setAccountActivations([]);
      }
      
  };
  const setActivations = (e) => {
    e.preventDefault();
    setActivationSearchTerm("");
    setActivationStartDate("");
    setActivationEndDate("");
    setActivationPage(1);
    getAccountActivations(1);
    
  };
  
  const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["Transaction Date", "Student Details", "Amount"];
    const data = accountActivations.map(item => [
      `${item.created_at?.short_date} ${item.created_at?.time}`,
      `${item.student} (${item.school})`,
      `UGX. ${item.amount}`
    ]);

    pdf.autoTable({ head: [columns], body: data });
    pdf.save("account_activations.pdf");
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= activationMeta) {
      setActivationPage(newPage);
    }
  };

  const headers = [
    { label: "Transaction Date", key: "created_at" },
    { label: "Student Details", key: "student" },
    { label: "Activation Type", key: "account" },
    { label: "Amount", key: "amount" }

  ];

  useEffect(() => {
    if (activationSearchTerm || activationStartDate || activationEndDate) {
      searchAccountActivations();
    } else {
      getAccountActivations(activationPage);
    }
  }, [activationPage]);

  return (
    <>
      <div class="heading-layout1 mg-b-5">
        <TableHeader
          subtitle="List of all the account activation invoices sorted by the most recent"   
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
              <Link class="dropdown-item" onClick={exportToPDF} ><i class="fas fa-file-export"></i>Export</Link>
          </div>
        </div>
      </div>

      <TransactionsSearchForm searchTerm={activationSearchTerm} setSearchTerm={setActivationSearchTerm} startDate={activationStartDate}
         setStartDate={setActivationStartDate} endDate={activationEndDate} setEndDate={setActivationEndDate} searchTransactions={searchAccountActivations}
         setTransactions={setActivations} setPage={setActivationPage} searchTermPlaceholder="Enter first or last name of user..."/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader />
        ) : (
          <TransactionsTable headers={headers} data={accountActivations}/>

        )}
      </div>

      <Pagination currentPage={activationPage} totalPages={activationMeta} onPageChange={handlePagination}/>
    </>
     
  );
}

export default AccountActivations;
